import React from "react";
import Calculator from "./components/Calculator";

const App: React.FC = () => {
  return (
    <div>
      <Calculator />
    </div>
  );
};

export default App;
